import { BrowserRouter } from "react-router-dom";
import UserProvider from "./components/contexts/useUserContext";
import Routes from './Routes';
import { GlobalStyle } from "./styles/Global";
// import Header from "./components/Header";
import AdminRoutes from './Routes/admin.js';
import {Navbar} from './components/Navbar'
import {Alert} from './components/Alert'
import RetailerRoutes from "./Routes/retailer";
import { Footer } from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

function App() {

  return (
    <BrowserRouter>
      <Alert />
      <GlobalStyle />
      <UserProvider>
      <ScrollToTop />
      <div className="site-content">
      <Navbar/>
        <Routes />
        <AdminRoutes />
        <RetailerRoutes />
      </ div>
      <Footer />
      </UserProvider>
    </BrowserRouter>
    
  );
}

export default App;
